import { CreateElement } from 'vue'
import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'
import { LK_NOTIFICATION_PAGES_ROUTES as ROUTES } from './utils'
import { lkStoreModule } from '@/store/modules/lk'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'pages',
    name: ROUTES.LAYOUT,
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "lk-publications.store" */
        './store'
      )

      registerModule(options)
      const storeModule = lkStoreModule.context(options.store)

      const promises = [
        storeModule.actions.getTopics().catch(() => ({})),
        storeModule.actions.getRoadmapsCount().catch(() => ({})),
        storeModule.actions.getMunMehCount().catch(() => ({})),
      ]

      await Promise.all(promises)

      return next()
    },
    component: {
      name: 'ViewLKNotificationPagesLayout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      // {
      //   path: '',
      //   name: ROUTES.LIST,
      //   component: (): PromiseVue => import(
      //     /* webpackChunkName: "notification-pages.list" */
      //     './LKNotificationPagesList.vue'
      //   ),
      // },
      {
        path: ':url(.*)',
        name: ROUTES.VIEW,
        props: true,
        component: (): PromiseVue => import(
          /* webpackChunkName: "lk-publications.list" */
          './LKNotificationPagesView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => createRoutes(options)

export default createModule
